import jwt_decode from "jwt-decode";
import { refreshAccessToken } from "./request";
import store from "../store";

async function checkToken() {
  let payload = { email: "", jwttoken: "" };
  let cookieToken = await localStorage.vue_token;

  if (cookieToken == null || cookieToken == "") {
    store.commit("userVUEX/checkLoginStatus", false);
    return false;
  } else {
    let decoded = jwt_decode(cookieToken);

    payload.email = decoded.email;
    payload.jwttoken = decoded.sub;

    store.commit("userVUEX/checkLoginStatus", true);
    return Date.now() <= decoded.exp * 1000;
  }
}

export default checkToken;

export const checkTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let time = null;
  if (Date.now() >= decoded.exp * 1000) {
    time = false;
  } else {
    time = true;
  }
  return time;
};

// Get Token
export const getToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getRefreshToken = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "refreshToken") {
        return cur[1];
      }
    }
  }
  return null;
};

export const getShowPreference = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "loginData") {
        return JSON.parse(cur[1]);
      }
    }
  }
  return null;
};

export const setShowPreference = (data) => {
  data.showPreference = false;
  console.log(data);
  document.cookie = `loginData=${JSON.stringify(
    data
  )}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
  // `loginData=${JSON.stringify(data)}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;`
};

// Remove Token
export const removeToken = () => {
  return localStorage.removeItem("vue_token");
};

// Set Token
export const setToken = (token) => {
  document.cookie = `accessToken=${token}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
};

export const setRefreshToken = (token) => {
  document.cookie =
    // `refreshToken=${token}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;`
    `refreshToken=${token}; expires=Wed, 16 Jan 2030 12:00:00 UTC; path=/;domain=hire3x.com;`;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie =
      name.trim() +
      "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=hire3x.com;";
    // name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
};

export const startTokenExpiryWatcher = () => {
  setInterval(async () => {
    if (checkBeforeTokenExpiry()) {
      // Token is expiring within the next 1 minute
      // Refresh the token
      await refreshAccessToken();
    }
  }, 60000); // Check every 1 minute
};

export const checkBeforeTokenExpiry = () => {
  let cookieToken = getToken();
  let decoded = jwt_decode(cookieToken);
  let expirationTime = decoded.exp * 1000;
  let currentTime = Math.floor(new Date().getTime());
  let timeDifference = expirationTime - currentTime;
  console.log(timeDifference);
  //check if token expires within 5 minutes
  if (timeDifference <= 300000) {
    return true;
  } else {
    return false;
  }
};
